var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoneyRedeem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74954 0.0316859C4.0657 0.317384 3.46395 2.10901 4.13163 3.35331H2.30233C1.03081 3.35331 0 4.38413 0 5.65564V7.74866C0 8.25517 0.36 8.67692 0.837209 8.77424C0.845581 8.77424 0.852907 8.77738 0.861279 8.77843C0.92093 8.78994 0.983721 8.79517 1.04651 8.79517H16.9535C17.0247 8.79517 17.0948 8.78785 17.1628 8.77424C17.64 8.67692 18 8.25517 18 7.74866V5.65564C18 4.38413 16.9692 3.35331 15.6977 3.35331H13.8684C14.536 2.10901 13.9343 0.317384 12.2515 0.0316859C11.5524 -0.0865699 10.8377 0.130058 10.3217 0.616686L9 1.86204L7.67826 0.616686C7.16233 0.130058 6.4486 -0.0865699 5.74954 0.0316859ZM6.81698 1.53029C6.58779 1.31366 6.26965 1.21738 5.95884 1.27076C4.94163 1.44238 4.81291 2.85099 5.78093 3.2068L6.18174 3.35331H8.37209V2.99645L6.81698 1.53029ZM12.2191 3.2068L11.8193 3.35331H9.62791V2.99645L11.183 1.53029C11.4122 1.31366 11.7303 1.21738 12.0412 1.27076C13.0584 1.44238 13.1881 2.85099 12.2191 3.2068Z",
    fill: "#2C2B38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.836914 14.4461V10.2507C0.836914 10.1387 0.933193 10.0508 1.04622 10.0508H6.44622C6.5854 10.0508 6.69738 10.1628 6.69738 10.3019V17.7531C6.69738 17.8912 6.5854 18.0043 6.44622 18.0043H4.39505C2.4297 18.0043 0.836914 16.4115 0.836914 14.4461Z",
    fill: "#2C2B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95361 17.7531C7.95361 17.8912 8.06559 18.0043 8.20478 18.0043H9.79547C9.93466 18.0043 10.0466 17.8912 10.0466 17.7531V10.3019C10.0466 10.1628 9.93466 10.0508 9.79547 10.0508H8.20478C8.06559 10.0508 7.95361 10.1628 7.95361 10.3019V17.7531Z",
    fill: "#2C2B38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5534 10.0508C11.4142 10.0508 11.3022 10.1628 11.3022 10.3019V17.7531C11.3022 17.8912 11.4142 18.0043 11.5534 18.0043H13.6046C15.5699 18.0043 17.1627 16.4115 17.1627 14.4461V10.2507C17.1627 10.1387 17.0664 10.0508 16.9534 10.0508H11.5534Z",
    fill: "#2C2B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoneyRedeem);
export default __webpack_public_path__ + "static/media/emoney-redeem.23ebf5828d13bb839c92775b5f50a569.svg";
export { ForwardRef as ReactComponent };